// extracted by mini-css-extract-plugin
export var alignBaseline = "_14-9";
export var alignCenter = "_14-5";
export var alignFlexEnd = "_14-7";
export var alignFlexStart = "_14-6";
export var alignSelfBaseline = "_14-e";
export var alignSelfCenter = "_14-a";
export var alignSelfFlexEnd = "_14-c";
export var alignSelfFlexStart = "_14-b";
export var alignSelfStretch = "_14-d";
export var alignStretch = "_14-8";
export var column = "_14-2";
export var columnReverse = "_14-4";
export var flex = "_14-0";
export var justifyCenter = "_14-f";
export var justifyFlexEnd = "_14-h";
export var justifyFlexStart = "_14-g";
export var justifySpaceAround = "_14-j";
export var justifySpaceBetween = "_14-i";
export var justifySpaceEvenly = "_14-k";
export var row = "_14-1";
export var rowReverse = "_14-3";
export var wrapNowrap = "_14-m";
export var wrapWrap = "_14-l";
export var wrapWrapReverse = "_14-n";